import { makeStyles } from '@epilot/journey-elements'

export const usePriceInformationTaxesStyles = makeStyles({
  container: {
    textAlign: 'right',
    color: 'var(--concorde-primary-text)'
  }
})
